import { Localized } from 'dg-web-shared/lib/Localization';
import { useNavigate } from 'react-router';
import { useParkingaboAuthedPathGeneration } from '../../RouteUtils.tsx';
import { FeedbackPopup } from '../../../components/FeedbackPopup.tsx';

export function VehicleMissingAlertRoute() {
    const navigate = useNavigate();
    const generateAuthedParkingaboPath = useParkingaboAuthedPathGeneration();

    return (
        <FeedbackPopup
            open={true}
            color="warning"
            onAbort={() => {
                navigate(generateAuthedParkingaboPath('products'));
            }}
            abortLabel={
                <Localized
                    de="Abbrechen"
                    fr="Annuler"
                    it="Annulla"
                    en="Cancel"
                />
            }
            onConfirm={() => {
                navigate(generateAuthedParkingaboPath('vehicles'));
            }}
            confirmLabel={
                <Localized
                    de="Weiter"
                    fr="Continuer"
                    it="Avanti"
                    en="Proceed"
                />
            }
            title={<VehicleMissingTitle />}
        >
            <p>
                <Localized
                    de="Bevor Sie ein neues Produkt hinzufügen können, müssen Sie mindestens 1 Fahrzeug registrieren."
                    fr="Avant de pouvoir ajouter un nouveau produit, vous devez enregistrer au moins 1 véhicule."
                    it="Prima di poter aggiungere un nuovo prodotto, devi registrare almeno 1 veicolo."
                    en="Before you can add a new product, you must register at least 1 vehicle."
                />
            </p>
        </FeedbackPopup>
    );
}

export function VehicleMissingTitle() {
    return (
        <Localized
            de="Fahrzeug fehlt"
            fr="Véhicule manquant"
            it="Veicolo mancante"
            en="Missing vehicle"
        />
    );
}
